/**
 * Status
 *
 * Renders a small badge with color-coded styling based on a status string.
 * Unknown statuses render with default styling. Optional className and disabled
 * state are supported for composition and visual adjustments.
 */
import React from "react";
import "./status.scss";

const statusColors: { [key: string]: string } = {
  Approved: "approved",
  Rejected: "rejected",
  Pending: "pending",
  "At Risk": "at-risk",
  "Not Started": "not-started",
  "On Hold": "on-hold",
  Cancelled: "cancelled",
  Completed: "completed",
  "In Progress - On Track": "in-progress-on-track",
  "In Progress - Off Track": "in-progress-off-track",
  "In Progress - At Risk": "in-progress-at-risk",
  Achieved: "achieved",
  Missed: "missed",
  Created: "created",
  "On Track": "on-track",
  "Off Track": "off-track",
  "Not Applicable": "not-applicable",
  "In Review": "in-review",
  "In Progress": "in-progress",
  Active: "active",
  Resolved: "resolved",
};

interface StatusProps {
  status: string;
  className?: string;
  isDisabled?: boolean;
}

const Status: React.FC<StatusProps> = ({ status, className, isDisabled }) => {
  return (
    <span
      className={`status-badge ${statusColors[status] ?? ""} table-cell-ellipsis ${className ?? ""}`}
      style={{ opacity: isDisabled ? "0.5" : "1" }}
    >
      {status}
    </span>
  );
};

export default Status;
